<template>
  <ValidationObserver ref="validator">
    <v-card
      flat
      max-width="480"
      class="mx-auto px-9 px-md-0 pt-12 py-lg-0 responsive-bg"
    >
      <v-card-title
        primary-title
        class="step-title pa-0 pa-md-10 font-weight-bold mb-12 justify-md-center headline"
      >
        Step 1
        <abbr class="mobile-hypen">-</abbr>
        <span>Tell us about yourself</span>
        <v-progress-linear indeterminate v-if="request.submitting" />
      </v-card-title>
      <div class="form-wrapper">
        <div class="mb-5 mb-md-12">
          <ValidationProvider
            name="first_name"
            rules="required|alpha"
            v-slot="{ errors }"
          >
            <v-text-field
              name="first_name"
              :error-messages="errors"
              v-model="request.first_name"
              label="First Name"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            name="last_name"
            rules="required|alpha"
            v-slot="{ errors }"
          >
            <v-text-field
              name="last_name"
              :error-messages="errors"
              v-model="request.last_name"
              label="Last Name"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            name="password"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              name="password"
              type="password"
              :error-messages="errors"
              v-model="request.password"
              label="Password"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            name="password_confirmation"
            :rules="request.password ? `required|confirm:@password` : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              name="password_confirmation"
              type="password"
              :error-messages="errors"
              v-model="request.password_confirmation"
              label="Password Confirmation"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <v-text-field
              name="email"
              type="email"
              :error-messages="errors"
              v-model="request.email"
              label="Email"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            name="phone_number"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              name="phone_number"
              type="phone_number"
              :error-messages="errors"
              v-model="request.phone_number"
              label="Phone Number"
              required
            />
          </ValidationProvider>
        </div>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-8 font-weight-bold title"
          @click.prevent="walk(true)"
          :disabled="request.submitting"
        >
          Continue as Tourist
        </v-btn>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-8 font-weight-bold title"
          @click.prevent="walk()"
          :disabled="request.submitting"
        >
          Continue as Tourist Operator
        </v-btn>
      </div>
    </v-card>
  </ValidationObserver>
</template>

<script>
import RegistrationRequest from '@request/Auth/RegistrationRequest';

export default {
  name: 'RegisterStep1',
  props: {
    request: {
      type: RegistrationRequest,
      required: true,
      default: () => {},
    },
  },
  methods: {
    async walk(isTourist = false) {
      const self = this;
      this.request.is_tourist = isTourist;
      self.$nextTick(async () => {
        if (await self.request.validate()) {
          let response = await self.request.testValidation(
            self.$refs.validator
          );

          response && self.$emit('step', 1);
        }
      });
    },
  },
};
</script>
